<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
    <path
      d="M17 2H3a1 1 0 00-1 1v14a1 1 0 001 1h14a1 1 0 001-1V3a1 1 0 00-1-1zm-4 12.59L11.59 16H8.41L7 14.59V11h6v3.59zM15 7H5V5h10v2z"
    />
  </svg>
</template>
